// extracted by mini-css-extract-plugin
export default {"slider":"Slider_slider__d1Ld9","tooltip":"Slider_tooltip__7epCp","thumb":"Slider_thumb__eKAxU"};